import { appendDataToListTable, renderListError } from '../crud/shared.js';
import { PageTitle } from '../../components.js';
import { Page } from '../base.js';

class ActivityListRow {
  static props = ['action', 'section', 'details', 'createdAt', 'createdBy'];
  static timl = `
    td {{ Props.action }}
    td {{ Props.section }}
    td {{ Props.details }}
    td.table-col-100.pr-4[style="white-space:nowrap;"] {{ Props.createdAt }}
    td.table-col-100 {{ Props.createdBy }}
  `;
}

export class LandingPage extends Page {
  static timlComponents = {
    PageTitle
  };

  static timl = `
    <PageTitle title="Recent Activity">
    table.resource-table[data-empty-title="No recent activity" data-empty-description="Activity across your account will appear here."]
      thead
        th Action
        th Collection
        th Name
        th Created At
        th Created By
      tbody#dashboard-activity-rows.fade
  `;

  static javascript() {
    const pageId = API.currentPageId;

    API.get(API.resourceUrl('activity'))
      .then(data => {
        if (!data || pageId !== API.currentPageId) return;
        appendDataToListTable('#dashboard-activity-rows', data.data, ActivityListRow, this.mapItemToRowData);
      })
      .catch(error => {
        console.error('get-activity error data:', error);
        renderListError('#dashboard-activity-rows', error, 'Recent Activity');

        if (error.message.includes("Firestore error") || error.message.includes("requires an index")) {
          console.warn('Activity data temporarily unavailable - database index being created');
        }
      })
      .finally(() => {
        console.log('get-activity finally callback');
      });
  }

  static mapItemToRowData(item) {
    return {
      action: item.action || '—',
      section: item.details?.collectionKey || item.collectionKey || item.resource || item.section || '—',
      details: item.details?.recordLabel || item.details?.message || item.recordLabel || item.description || '—',
      createdAt: Util.formatDate(item.createdAt),
      createdBy: item.createdByEmail || item.createdBy || '—'
    };
  }
}
